import { render, staticRenderFns } from "./boxSearchFree.vue?vue&type=template&id=592e7c0a&scoped=true&"
import script from "./boxSearchFree.vue?vue&type=script&lang=js&"
export * from "./boxSearchFree.vue?vue&type=script&lang=js&"
import style0 from "./boxSearchFree.vue?vue&type=style&index=0&id=592e7c0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592e7c0a",
  null
  
)

export default component.exports